import * as React from "react";
import { cn } from "../../libs/utils";



const Input = React.forwardRef(
  (
    {
      newInput = false,
      className,
      type,
      ...props
    },
    ref,
    ) => {
        const normalInputClasses =
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50";
        
        const defaultClassName = newInput
          ? "!bg-[#ECEFF3] w-full !rounded-[8px] h-[56px] shadow-none !border-0 px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
          : normalInputClasses;
    return (
      <input
        type={type}
        className={cn(defaultClassName, className)}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
